import Resizer from 'react-image-file-resizer';
import Swal from 'sweetalert2';
import { fileChangedHandler } from '../../components/helpers';
import UploadProfilePhoto from '../../components/helpers/guests/upload_photo';

export const uploadDocumentsInput = ({
  formID,
  secString,
  varFile,
  filling,
  inputs,
  set_documentSideA,
  set_documentSideB,
  errorInputs,
  image,
  set_imagePreview,
}) => {
  const buttonMessage = () => {
    if (filling && (varFile || inputs[formID])) return `Cambiar ${secString}`;
    if (!varFile && filling) return `Sube ${secString}`;
    if (inputs[formID] && !filling) return `Descargar ${secString}`;
    return '';
  };
  if (buttonMessage())
    return (
      <div>
        <label
          className={`ui compact button ${errorInputs[formID] ? 'error' : ''}`}
          htmlFor={formID}
          onClick={() => {
            if (inputs[formID] && !filling) window.open(inputs[formID]);
          }}
        >
          {buttonMessage()}
        </label>
        {filling && (
          <input
            onChange={(event) =>
              fileChangedHandler(
                event,
                (uri) => {
                  if (event.target.id === 'documentSideA') set_documentSideA(uri);
                  if (event.target.id === 'documentSideB') set_documentSideB(uri);
                },
                Swal,
                Resizer,
                image,
                set_imagePreview
              )
            }
            type="file"
            id={formID}
            accept=".jpg,.jpeg,.png"
            style={{ display: 'none' }}
          />
        )}
      </div>
    );
  return <></>;
};

const VolunteerForm = (props) => {
  const {
    input,
    inputs,
    selectArea,
    selectkindofid,
    image,
    set_image,
    errorInputs,
    adminView,
    filling,
    selectAreaSuspended,
    documentSideA,
    set_documentSideA,
    documentSideB,
    set_documentSideB,
    isPrinting,
  } = props;

  return (
    <>
      <div className="main-form">
        <h4>DATOS PERSONALES DEL VOLUNTARIO</h4>
        <UploadProfilePhoto
          name={'image'}
          labelDescription={'foto'}
          imageFile={image}
          filling={filling}
          errorInputs={errorInputs}
          inputs={inputs}
          set_image={set_image}
        />
        <div className={`${isPrinting ? 'hidden' : ''}`}>
          {uploadDocumentsInput({
            formID: 'documentSideA',
            secString: 'el lado frontal del documento',
            varFile: documentSideA,
            filling,
            inputs,
            set_documentSideA,
            errorInputs,
            image,
          })}
          {uploadDocumentsInput({
            formID: 'documentSideB',
            secString: 'el lado de atrás del documento',
            varFile: documentSideB,
            set_documentSideB,
            filling,
            inputs,
            errorInputs,
            image,
          })}
        </div>
        <p>
          NOMBRES {input({ input: 'name', placeholder: 'Nombre' })} APELLIDOS{' '}
          {input({ input: 'lastName', placeholder: 'Apellido' })}
        </p>
        <p>
          DOCUMENTO DE IDENTIDAD {selectkindofid()}
          {input({
            disabled: adminView,
            input: 'identification',
            type: 'number',
            placeholder: 'Cédula',
          })}
        </p>
        <p>
          TELÉFONOS: RESIDENCIA{' '}
          {input({
            input: 'homePhone',
            type: 'number',
            placeholder: 'Teléfono residencia',
          })}{' '}
          TRABAJO{' '}
          {input({
            input: 'workPhone',
            type: 'number',
            placeholder: 'Teléfono Trabajo',
          })}
        </p>
        <p>
          CELULAR {input({ input: 'phone', type: 'number', placeholder: 'Celular' })} EMAIL{' '}
          {input({ input: 'email', type: 'email', placeholder: 'Email' })}
        </p>
        <p>DIRECCIÓN RESIDENCIA {input({ input: 'address', placeholder: 'Dirección' })}</p>
        <p>
          NOMBRE Y TELÉFONO DE UN FAMILIAR{' '}
          {input({ input: 'relativeName', placeholder: 'Nombre del familiar' })}{' '}
          {input({
            input: 'relativePhone',
            placeholder: 'Teléfono del familiar',
            type: 'number',
          })}
        </p>
        <p>
          NOMBRE Y TELÉFONO DEL LIDER{' '}
          {input({ input: 'leaderName', placeholder: 'Nombre del lider' })}{' '}
          {input({
            input: 'leaderPhone',
            placeholder: 'Teléfono del líder',
            type: 'number',
          })}
        </p>
        <p>Areas en las que sirves: {selectArea()}</p>
        {selectAreaSuspended()}
      </div>
      <div className="minors-form">
        <h3>Sólo diligenciar en caso de ser menor de edad:</h3>
        <p>Declaro que como firmante y en ejercicio de la patria potestad</p>
        <p>
          Nombre del Acudiente: {input({ input: 'parentsName', placeholder: 'Nombre Acudiente' })}{' '}
          Cédula del acudiente:{' '}
          {input({
            input: 'parentsIdentification',
            type: 'number',
            placeholder: 'Cédula acudiente',
          })}
        </p>
        <p>
          Parentesco: {input({ input: 'kindOfParent', placeholder: 'Parentesco' })} Teléfono:{' '}
          {input({
            input: 'parentsPhone',
            type: 'number',
            placeholder: 'Teléfono del acudiente',
          })}
        </p>
        <p>
          Tengo la autoridad para dar este consentimiento informado, otorgar la exención de
          responsabilidad y asumir la asunción del riesgo para la participación del menor de edad.
        </p>
        <div
          style={{
            padding: '80px 0 0 0',
            maxWidth: '200px',
            display: isPrinting ? 'block' : 'none',
          }}
        >
          <p style={{ borderTop: '1px solid black' }}>Firma Acudiente</p>
        </div>
      </div>
    </>
  );
};
export default VolunteerForm;
